const gqlTintToLocalTint = {
    ORANGE: 'orange',
    TEAL: 'teal',
    BEIGE: 'beige',
    PURPLE: 'purple',
    GREEN: 'green',
};

export { gqlTintToLocalTint };
